import { Agriculture, ArticleOutlined, Dashboard } from "@mui/icons-material";

export const farmerMenu = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    path: "/admin",
    items: [],
  },
  {
    title: "Aktifitas Harian",
    icon: <Agriculture />,
    path: "/petani/aktifitas-harian",
    items: [],
  },
  {
    title: "Estimasi Panen",
    icon: <Agriculture />,
    path: "/petani/estimasi-panen",
    items: [],
  },
  {
    title: "Panen",
    icon: <Agriculture />,
    path: "/petani/panen",
    items: [],
  },
  {
    title: "Nota Petani",
    icon: <ArticleOutlined />,
    path: "/petani/nota-petani",
    items: [],
  },
];
